import React, { Component } from "react";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Table from "react-bootstrap/Table";
import Alert from "react-bootstrap/Alert";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/Badge";
import { withRouter } from "../withRouter";
import {
  createProject,
  deleteProject,
  exportVotesProject,
  getProject,
  importVotesProject,
  updateProject,
  uploadProjectImage,
  uploadStatements,
  updateLandingPageConfig,
  uploadExpertPhoto,
} from "../api";
import AdminNavBar from "./AdminNavBar";
import LoadingButton from "./LoadingButton";
import {
  CardHeading,
  InfoCircle,
  CardImage,
  QuestionCircle,
  Download,
  BarChart,
  Palette,
  Globe,
} from "react-bootstrap-icons";
import { BASE_URL } from "../config";
import Questions from "./Questions";

class ModifyProject extends Component {
  state = {
    name: "",

    logo_file: null,
    voter_footer_image_file: null,
    presenter_footer_image_file: null,
    presenter_background_image_file: null,

    statements: [],
    professions: [],
    events: [],
    import_file: null,
    importEventName: "",
    // "" = ajouter un event ; id = remplacer l'event visé (corriger des
    // résultats sans accumuler de doublons dans les stats projet).
    importReplaceEventId: "",
    isImportingVotes: false,
    showImportVotesAlert: "",
    importResult: null,
    isUploadingStatements: false,
    isUploadingLogo: false,
    showInformationAlert: "",
    showLogoUploadAlert: "",
    showStatementUploadAlert: "",
    showColorsAlert: "",
    showLandingPageAlert: "",
    backgroundColor: "#FFFFFF",
    headerBackgroundColor: "#FFFFFF",
    statementBackgroundColor: "#FFFFFF",
    voterFooterImage: null,
    presenterBackgroundImage: null,
    logoUploadTimestamp: Date.now(),
    voterFotterUploadTimestamp: Date.now(),
    presenterFooterUploadTimestamp: Date.now(),
    presenterBackgroundUploadTimestamp: Date.now(),

    // Landing page configuration
    showHeaderLogo: true,
    headerLogoFile: null,
    headerLogoUrl: null,
    footerLogoFile: null,
    footerLogoUrl: null,
    showExpertsCarousel: false,
    landingExperts: [],
    showContactForm: false,
    contactEmail: "",
    contactFormTitle: "Contact",
    showVimeoVideo: false,
    vimeoVideoId: "",
    vimeoVideoTitle: "",
    vimeoVideoThumbnailFile: null,
    vimeoVideoThumbnailUrl: null,
    vimeoThumbnailUploadTimestamp: Date.now(),
    landingFooterText: "",
    landingLayoutConfig: {},
    headerLogoUploadTimestamp: Date.now(),
    footerLogoUploadTimestamp: Date.now(),
  };

  async componentDidMount() {
    if (this.props.params.project_id !== "new") {
      const project = await getProject(this.props.params.project_id);
      this.setState({
        name: project.name,
        backgroundColor: project.background_color,
        headerBackgroundColor: project.header_background_color,
        statementBackgroundColor: project.statement_background_color,

        voter_footer_image_url: project.voter_footer_image_url,
        presenter_footer_image_url: project.presenter_footer_image_url,
        presenter_background_image_url: project.presenter_background_image_url,

        logo_url: project.logo_url,

        statements: project.statements,
        professions: project.professions ?? [],
        events: project.events ?? [],

        // Landing page configuration
        showHeaderLogo: project.show_header_logo ?? true,
        headerLogoUrl: project.header_logo_url,
        footerLogoUrl: project.footer_logo_url,
        showExpertsCarousel: project.show_experts_carousel ?? false,
        landingExperts: project.landing_experts ?? [],
        showContactForm: project.show_contact_form ?? false,
        contactEmail: project.contact_email ?? "",
        contactFormTitle: project.contact_form_title ?? "Contact",
        showVimeoVideo: project.show_vimeo_video ?? false,
        vimeoVideoId: project.vimeo_video_id ?? "",
        vimeoVideoTitle: project.vimeo_video_title ?? "",
        vimeoVideoThumbnailUrl: project.vimeo_video_thumbnail_url,
        landingFooterText: project.landing_footer_text ?? "",
        landingLayoutConfig: project.landing_layout_config ?? {},
      });
    }
  }

  handleDelete = async () => {
    try {
      await deleteProject(this.props.params.project_id);
      this.props.navigate(`/admin`);
    } catch (err) {
      this.handleError(err);
    }
  };

  handleChange = (e) => {
    const target = e.target;
    const name = target.name;

    if (target.type === "file") {
      // Handle file input
      const file = target.files[0]; // Get the selected file
      this.setState({ [name]: file }); // You can set the file object to your state
    } else {
      // Handle other input types
      const value = target.value;
      this.setState({ [name]: value });
    }
  };

  handleSubmit = async () => {
    let project;
    if (this.props.params.project_id === "new") {
      project = await createProject({
        name: this.state.name,
      });

      this.props.navigate(`/admin/project/${project.id}`);
    } else {
      try {
        project = await updateProject(this.props.params.project_id, {
          name: this.state.name,
        });
      } catch (err) {
        this.setState({
          showInformationAlert: "danger",

          error: err.response.data.detail,
        });
      }
    }
    this.setState({
      ...project,
      showInformationAlert: "success",
    });
  };

  handleFieldUpdate = async (field, value) => {
    let project;

    try {
      project = await updateProject(this.props.params.project_id, {
        [field]: value,
      });
    } catch (err) {
      this.setState({
        showFieldUpdateAlert: "danger",
        error: err.response.data.detail,
      });
    }

    this.setState({
      ...project,
      showFieldUpdateAlert: "success",
    });
  };

  handleColors = async () => {
    let project;

    try {
      project = await updateProject(this.props.params.project_id, {
        background_color: this.state.backgroundColor,
        header_background_color: this.state.headerBackgroundColor,
        statement_background_color: this.state.statementBackgroundColor,
      });
    } catch (err) {
      this.setState({
        showColorsAlert: "danger",

        error: err.response.data.detail,
      });
    }

    this.setState({
      ...project,
      showColorsAlert: "success",
    });
  };

  handleStatementsUpload = async () => {
    if (this.state.statement_file) {
      this.setState({ isUploadingStatements: true });
      try {
        const statements = await uploadStatements(
          this.props.params.project_id,
          this.state.statement_file
        );
        // Re-fetch le projet : les professions détectées dans le CSV ne sont
        // pas dans la réponse d'upload (liste de statements).
        const project = await getProject(this.props.params.project_id);
        this.setState({
          statements,
          professions: project.professions ?? [],
          isUploadingStatements: false,
          showStatementUploadAlert: "success",
          statement_file: null,
        });
      } catch (err) {
        this.setState({
          isUploadingStatements: false,

          showStatementUploadAlert: "danger",
          error: err.response.data.detail,
        });
      }
    }
  };

  handleLogoUpload = async () => {
    if (this.state.logo_file) {
      this.setState({ isUploadingLogo: true });
      try {
        const project = await uploadProjectImage(
          this.props.params.project_id,
          this.state.logo_file,
          "logo"
        );
        this.setState({
          logo_url: project.logo_url,
          showLogoUploadAlert: "success",
          logoUploadTimestamp: Date.now(), // Add this line

          logo_file: null,
        });
      } catch (err) {
        this.setState({
          showLogoUploadAlert: "danger",
          error: err.response.data.detail,
        });
      }
    }
  };

  handleVoterFooterImageUpload = async () => {
    if (this.state.voter_footer_image_file) {
      this.setState({ isUploadingLogo: true });
      try {
        const project = await uploadProjectImage(
          this.props.params.project_id,
          this.state.voter_footer_image_file,
          "voter_footer"
        );
        this.setState({
          voter_footer_image_url: project.voter_footer_image_url,
          voterFotterUploadTimestamp: Date.now(),
          showLogoUploadAlert: "success",
          voter_footer_image_file: null,
        });
      } catch (err) {
        this.setState({
          showLogoUploadAlert: "danger",
          error: err.response.data.detail,
        });
      }
    }
  };

  handlePresenterFooterImageUpload = async () => {
    if (this.state.presenter_footer_image_file) {
      this.setState({ isUploadingLogo: true });
      try {
        const project = await uploadProjectImage(
          this.props.params.project_id,
          this.state.presenter_footer_image_file,
          "presenter_footer"
        );
        this.setState({
          presenter_footer_image_url: project.presenter_footer_image_url,
          presenterFooterUploadTimestamp: Date.now(),
          showLogoUploadAlert: "success",
          presenter_footer_image_file: null,
        });
      } catch (err) {
        this.setState({
          showLogoUploadAlert: "danger",
          error: err.response.data.detail,
        });
      }
    }
  };

  handlePresenterBackgroundImageUpload = async () => {
    if (this.state.presenter_background_image_file) {
      this.setState({ isUploadingLogo: true });
      try {
        const project = await uploadProjectImage(
          this.props.params.project_id,
          this.state.presenter_background_image_file,
          "presenter_background"
        );
        this.setState({
          presenter_background_image_url:
            project.presenter_background_image_url,
          showLogoUploadAlert: "success",
          presenter_background_image_file: null,
          presenterBackgroundUploadTimestamp: Date.now(),
        });
      } catch (err) {
        this.setState({
          showLogoUploadAlert: "danger",
          error: err.response.data.detail,
        });
      }
    }
  };

  handleLandingPageConfig = async () => {
    try {
      const config = {
        show_header_logo: this.state.showHeaderLogo,
        show_experts_carousel: this.state.showExpertsCarousel,
        landing_experts: this.state.landingExperts,
        show_contact_form: this.state.showContactForm,
        contact_email: this.state.contactEmail,
        contact_form_title: this.state.contactFormTitle,
        show_vimeo_video: this.state.showVimeoVideo,
        vimeo_video_id: this.state.vimeoVideoId,
        vimeo_video_title: this.state.vimeoVideoTitle,
        vimeo_video_thumbnail_url: this.state.vimeoVideoThumbnailUrl,
        landing_footer_text: this.state.landingFooterText,
        landing_layout_config: this.state.landingLayoutConfig,
      };

      await updateLandingPageConfig(this.props.params.project_id, config);

      this.setState({
        showLandingPageAlert: "success",
      });
    } catch (err) {
      this.setState({
        showLandingPageAlert: "danger",
        error: err.response?.data?.detail || err.message,
      });
    }
  };

  addExpert = () => {
    const newExpert = {
      name: "",
      title: "",
      specialty: "",
      photo_url: null,
    };
    this.setState({
      landingExperts: [...this.state.landingExperts, newExpert],
    });
  };

  removeExpert = (index) => {
    const experts = [...this.state.landingExperts];
    experts.splice(index, 1);
    this.setState({
      landingExperts: experts,
    });
  };

  updateExpert = (index, field, value) => {
    const experts = [...this.state.landingExperts];
    experts[index][field] = value;
    this.setState({
      landingExperts: experts,
    });
  };

  uploadExpertPhoto = async (index, file) => {
    try {
      const result = await uploadExpertPhoto(
        this.props.params.project_id,
        index,
        file
      );
      this.updateExpert(index, "photo_url", result.photo_url);
    } catch (err) {
      console.error("Error uploading expert photo:", err);
    }
  };

  handleHeaderLogoUpload = async () => {
    if (this.state.headerLogoFile) {
      this.setState({ isUploadingLogo: true });
      try {
        const project = await uploadProjectImage(
          this.props.params.project_id,
          this.state.headerLogoFile,
          "header_logo"
        );
        this.setState({
          headerLogoUrl: project.header_logo_url,
          showLogoUploadAlert: "success",
          headerLogoUploadTimestamp: Date.now(),
          headerLogoFile: null,
        });
      } catch (err) {
        this.setState({
          showLogoUploadAlert: "danger",
          error: err.response?.data?.detail || err.message,
        });
      } finally {
        this.setState({ isUploadingLogo: false });
      }
    }
  };

  handleFooterLogoUpload = async () => {
    if (this.state.footerLogoFile) {
      this.setState({ isUploadingLogo: true });
      try {
        const project = await uploadProjectImage(
          this.props.params.project_id,
          this.state.footerLogoFile,
          "footer_logo"
        );
        this.setState({
          footerLogoUrl: project.footer_logo_url,
          showLogoUploadAlert: "success",
          footerLogoUploadTimestamp: Date.now(),
          footerLogoFile: null,
        });
      } catch (err) {
        this.setState({
          showLogoUploadAlert: "danger",
          error: err.response?.data?.detail || err.message,
        });
      } finally {
        this.setState({ isUploadingLogo: false });
      }
    }
  };

  handleVimeoThumbnailUpload = async () => {
    if (this.state.vimeoVideoThumbnailFile) {
      this.setState({ isUploadingLogo: true });
      try {
        const project = await uploadProjectImage(
          this.props.params.project_id,
          this.state.vimeoVideoThumbnailFile,
          "vimeo_thumbnail"
        );
        this.setState({
          vimeoVideoThumbnailUrl: project.vimeo_video_thumbnail_url,
          showLogoUploadAlert: "success",
          vimeoThumbnailUploadTimestamp: Date.now(),
          vimeoVideoThumbnailFile: null,
        });
      } catch (err) {
        this.setState({
          showLogoUploadAlert: "danger",
          error: err.response?.data?.detail || err.message,
        });
      } finally {
        this.setState({ isUploadingLogo: false });
      }
    }
  };

  async exportVotes() {
    try {
      await exportVotesProject(this.props.params.project_id);
    } catch (err) {
      this.handleError(err);
    }
  }

  // Import d'un fichier de résultats (format export-votes) : recrée un
  // event complet terminé (votants + votes) dans le projet.
  handleImportVotes = async () => {
    if (!this.state.import_file) return;
    this.setState({ isImportingVotes: true });
    try {
      const result = await importVotesProject(
        this.props.params.project_id,
        this.state.import_file,
        this.state.importEventName,
        this.state.importReplaceEventId
      );
      // Recharger les events : la liste de remplacement doit refléter l'event
      // qui vient d'être créé (et ne plus proposer celui qui a été remplacé).
      const project = await getProject(this.props.params.project_id);
      this.setState({
        isImportingVotes: false,
        showImportVotesAlert: "success",
        importResult: result,
        import_file: null,
        importEventName: "",
        importReplaceEventId: "",
        events: project.events ?? [],
      });
    } catch (err) {
      this.setState({
        isImportingVotes: false,
        showImportVotesAlert: "danger",
        importResult: null,
        error: err.response?.data?.detail || err.message,
      });
    }
  };
  render() {
    return (
      <div style={{ backgroundColor: "#F6F7F9", minHeight: "100vh" }}>
        <AdminNavBar />
        <Container fluid className="px-5 pt-3 pb-5">
          <div
            className="border-bottom mb-3"
            style={{
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
              }}
            >
              <CardHeading size={26}></CardHeading>
              <h2 className="ms-3">Project</h2>
            </div>
          </div>

          {/* Project Information Card */}
          <div
            className="border-bottom mb-3"
            style={{
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                alignItems: "center",
              }}
            >
              <InfoCircle size={26}></InfoCircle>
              <h3 className="ms-3">Information</h3>
            </div>
          </div>

          <Alert
            show={this.state.showInformationAlert !== ""}
            variant={this.state.showInformationAlert}
          >
            <Alert.Heading>
              {this.state.showInformationAlert === "success"}
            </Alert.Heading>
            <p>
              {this.state.showInformationAlert === "success"
                ? "Information successfully updated."
                : "Error when updating information : " + this.state.error}
            </p>
            <hr />
            <div className="d-flex justify-content-end">
              <Button
                onClick={() => this.setState({ showInformationAlert: "" })}
                variant={"outline-" + this.state.showInformationAlert}
              >
                Close
              </Button>
            </div>
          </Alert>

          <Card
            className="mb-4"
            style={{
              borderWidth: 0,
              boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
            }}
          >
            <Card.Header as="h5">Basic Information</Card.Header>
            <Card.Body>
              <Form>
                <Row xs={1} md={3} className="mb-3">
                  <Col>
                    <Form.Group>
                      <Form.Label>Project Name</Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        value={this.state.name}
                        onChange={this.handleChange}
                        placeholder="Enter project name"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <LoadingButton
                  onClick={this.handleSubmit.bind(this)}
                  variant="primary"
                >
                  {this.props.params.project_id === "new"
                    ? "Create Project"
                    : "Save Information"}
                </LoadingButton>
              </Form>
            </Card.Body>
          </Card>
          {this.props.params.project_id !== "new" && (
            <>
              {/* Images Section */}
              <div
                className="border-bottom mb-3 mt-3"
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CardImage size={26}></CardImage>
                  <h3 className="ms-3">Images</h3>
                </div>
              </div>
              <Alert
                show={this.state.showLogoUploadAlert !== ""}
                variant={this.state.showLogoUploadAlert}
              >
                <Alert.Heading>
                  {this.state.showLogoUploadAlert === "success"}
                </Alert.Heading>
                <p>
                  {this.state.showLogoUploadAlert === "success"
                    ? "Image successfully uploaded."
                    : "Error when uploading image: " + this.state.error}
                </p>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => this.setState({ showLogoUploadAlert: "" })}
                    variant={"outline-" + this.state.showLogoUploadAlert}
                  >
                    Close
                  </Button>
                </div>
              </Alert>
              {/* Project Logo Card */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Project Logo</Card.Header>
                <Card.Body>
                  <Row xs={1} md={3} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>Logo File</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="logo_file"
                          type="file"
                          accept="image/*"
                        />
                        <Form.Text className="text-muted">
                          <b>Format required:</b> PNG or JPG file of size
                          100x300px
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    {this.state.logo_url && (
                      <Col>
                        <div className="text-center">
                          <p className="mb-2">
                            <strong>Current Logo:</strong>
                          </p>
                          <img
                            src={
                              BASE_URL +
                              "/projects/" +
                              this.props.params.project_id +
                              "/data/logo" +
                              "?t=" +
                              this.state.logoUploadTimestamp
                            }
                            alt="Project Logo"
                            style={{
                              width: "100%",
                              height: 100,
                              objectFit: "contain",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                  <div className="d-flex gap-2">
                    <LoadingButton
                      onClick={this.handleLogoUpload.bind(this)}
                      disabled={!this.state.logo_file}
                      variant="primary"
                    >
                      Upload Logo
                    </LoadingButton>
                    {this.state.logo_url && (
                      <LoadingButton
                        onClick={this.handleFieldUpdate.bind(
                          this,
                          "logo_url",
                          ""
                        )}
                        variant="danger"
                      >
                        Delete Logo
                      </LoadingButton>
                    )}
                  </div>
                </Card.Body>
              </Card>
              {/* Voter Footer Image Card */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Voter Footer Image</Card.Header>
                <Card.Body>
                  <Row xs={1} md={3} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>Footer Image File</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="voter_footer_image_file"
                          type="file"
                          accept="image/*"
                        />
                        <Form.Text className="text-muted">
                          <b>Format required:</b> PNG or SVG file of size
                          1920x54px
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    {this.state.voter_footer_image_url && (
                      <Col>
                        <div className="text-center">
                          <p className="mb-2">
                            <strong>Current Footer Image:</strong>
                          </p>
                          <img
                            src={
                              BASE_URL +
                              "/projects/" +
                              this.props.params.project_id +
                              "/data/voter_footer" +
                              "?t=" +
                              this.state.voterFotterUploadTimestamp
                            }
                            alt="Voter Footer"
                            style={{
                              width: "100%",
                              height: 100,
                              objectFit: "contain",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                  <div className="d-flex gap-2">
                    <LoadingButton
                      onClick={this.handleVoterFooterImageUpload}
                      disabled={!this.state.voter_footer_image_file}
                      variant="primary"
                    >
                      Upload Footer Image
                    </LoadingButton>
                    {this.state.voter_footer_image_url && (
                      <LoadingButton
                        onClick={this.handleFieldUpdate.bind(
                          this,
                          "voter_footer_image_url",
                          ""
                        )}
                        variant="danger"
                      >
                        Delete Footer Image
                      </LoadingButton>
                    )}
                  </div>
                </Card.Body>
              </Card>
              {/* Presenter Footer Image Card */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Presenter Footer Image</Card.Header>
                <Card.Body>
                  <Row xs={1} md={3} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>Footer Image File</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="presenter_footer_image_file"
                          type="file"
                          accept="image/*"
                        />
                        <Form.Text className="text-muted">
                          <b>Format required:</b> PNG or SVG file of size
                          1920x148px. If left empty, the Voter Footer Image is
                          used.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    {this.state.presenter_footer_image_url && (
                      <Col>
                        <div className="text-center">
                          <p className="mb-2">
                            <strong>Current Footer Image:</strong>
                          </p>
                          <img
                            src={
                              BASE_URL +
                              "/projects/" +
                              this.props.params.project_id +
                              "/data/presenter_footer" +
                              "?t=" +
                              this.state.presenterFooterUploadTimestamp
                            }
                            alt="Presenter Footer"
                            style={{
                              width: "100%",
                              height: 100,
                              objectFit: "contain",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                  <div className="d-flex gap-2">
                    <LoadingButton
                      onClick={this.handlePresenterFooterImageUpload}
                      disabled={!this.state.presenter_footer_image_file}
                      variant="primary"
                    >
                      Upload Footer Image
                    </LoadingButton>
                    {this.state.presenter_footer_image_url && (
                      <LoadingButton
                        onClick={this.handleFieldUpdate.bind(
                          this,
                          "presenter_footer_image_url",
                          ""
                        )}
                        variant="danger"
                      >
                        Delete Footer Image
                      </LoadingButton>
                    )}
                  </div>
                </Card.Body>
              </Card>
              {/* Presenter Background Image Card */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Presenter Background Image</Card.Header>
                <Card.Body>
                  <Row xs={1} md={3} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>Background Image File</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="presenter_background_image_file"
                          type="file"
                          accept="image/*"
                        />
                        <Form.Text className="text-muted">
                          <b>Format required:</b> PNG or JPG file of size
                          160x700px
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    {this.state.presenter_background_image_url && (
                      <Col>
                        <div className="text-center">
                          <p className="mb-2">
                            <strong>Current Background:</strong>
                          </p>
                          <img
                            src={
                              BASE_URL +
                              "/projects/" +
                              this.props.params.project_id +
                              "/data/presenter_background" +
                              "?t=" +
                              this.state.presenterBackgroundUploadTimestamp
                            }
                            alt="Presenter Background"
                            style={{
                              width: "100%",
                              height: 100,
                              objectFit: "contain",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>
                  <div className="d-flex gap-2">
                    <LoadingButton
                      onClick={this.handlePresenterBackgroundImageUpload.bind(
                        this
                      )}
                      disabled={!this.state.presenter_background_image_file}
                      variant="primary"
                    >
                      Upload Background Image
                    </LoadingButton>
                    {this.state.presenter_background_image_url && (
                      <LoadingButton
                        onClick={this.handleFieldUpdate.bind(
                          this,
                          "presenter_background_image_url",
                          ""
                        )}
                        variant="danger"
                      >
                        Delete Background Image
                      </LoadingButton>
                    )}
                  </div>
                </Card.Body>
              </Card>
              {/* Statements Section */}
              <div
                className="border-bottom mb-3 mt-3"
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <QuestionCircle size={26}></QuestionCircle>
                  <h3 className="ms-3">Statements</h3>
                </div>
              </div>

              <Alert
                show={this.state.showStatementUploadAlert !== ""}
                variant={this.state.showStatementUploadAlert}
              >
                <Alert.Heading>
                  {this.state.showStatementUploadAlert === "success"}
                </Alert.Heading>
                <p>
                  {this.state.showStatementUploadAlert === "success"
                    ? "Statements successfully uploaded."
                    : "Error when uploading statements: " + this.state.error}
                </p>
                <hr />
                <div className="d-flex justify-content-end">
                  <LoadingButton
                    onClick={() =>
                      this.setState({ showStatementUploadAlert: "" })
                    }
                    variant={"outline-" + this.state.showStatementUploadAlert}
                  >
                    Close
                  </LoadingButton>
                </div>
              </Alert>

              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Upload Statements</Card.Header>
                <Card.Body>
                  <Row xs={1} md={2} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>CSV File</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="statement_file"
                          type="file"
                          accept=".csv"
                        />
                        <Form.Text className="text-muted">
                          <b>CSV format required:</b>
                          <br />
                          Required columns: "order_number" (statement number)
                          and "statement_string" (statement content).
                          <br />
                          Optional color columns: "background_color",
                          "header_background_color",
                          "statement_background_color" (hex colors like
                          #FFFFFF).
                          <br />
                          For versioned content, use suffixes like
                          "statement_string_1", "background_color_2", etc.
                          <br />
                          Optional profession columns: "profession_&lt;Name&gt;"
                          (e.g. "profession_Médecin"). Put 1/x/oui in the cell
                          if the statement applies to that profession; leave
                          all profession cells empty for a statement common to
                          all. Column order defines the choice order shown to
                          voters.
                          <br />
                          Delimiters: semicolon or comma.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <LoadingButton
                    onClick={this.handleStatementsUpload.bind(this)}
                    disabled={!this.state.statement_file}
                    variant="primary"
                  >
                    Upload Statements
                  </LoadingButton>
                </Card.Body>
              </Card>

              {this.state.statements.length > 0 && (
                <Card
                  className="mb-4"
                  style={{
                    borderWidth: 0,
                    boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                  }}
                >
                  <Card.Header as="h5">
                    Current Statements ({this.state.statements.length})
                  </Card.Header>
                  <Card.Body>
                    <div className="mb-3">
                      <span className="me-2">Detected professions:</span>
                      {this.state.professions.length > 0 ? (
                        this.state.professions.map((profession) => (
                          <Badge
                            key={profession}
                            bg="primary"
                            className="me-1"
                          >
                            {profession}
                          </Badge>
                        ))
                      ) : (
                        <span style={{ color: "#999" }}>
                          None — same questionnaire for all voters
                        </span>
                      )}
                    </div>
                    <div className="table-responsive">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Order Number</th>
                            <th>Statement</th>
                            <th>Session Number</th>
                            <th>Session Name</th>
                            <th>Session Subtitle</th>
                            <th>Statement Version</th>
                            {this.state.professions.length > 0 && (
                              <th>Professions</th>
                            )}
                            <th>Background Color</th>
                            <th>Header Color</th>
                            <th>Statement Color</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.statements.map((statement, index) => (
                            <tr key={index}>
                              <td>{statement.order_number}</td>
                              <td
                                style={{
                                  maxWidth: "300px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {statement.statement_string}
                              </td>
                              <td>{statement.session_number}</td>
                              <td>{statement.session_name}</td>
                              <td>{statement.session_subtitle}</td>
                              <td>{statement.version}</td>
                              {this.state.professions.length > 0 && (
                                <td>
                                  {statement.professions?.length > 0 ? (
                                    statement.professions.join(", ")
                                  ) : (
                                    <small style={{ color: "#999" }}>
                                      All
                                    </small>
                                  )}
                                </td>
                              )}
                              <td>
                                {statement.background_color ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor:
                                          statement.background_color,
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                      }}
                                    ></div>
                                    <small>{statement.background_color}</small>
                                  </div>
                                ) : (
                                  <small style={{ color: "#999" }}>
                                    Projet
                                  </small>
                                )}
                              </td>
                              <td>
                                {statement.header_background_color ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor:
                                          statement.header_background_color,
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                      }}
                                    ></div>
                                    <small>
                                      {statement.header_background_color}
                                    </small>
                                  </div>
                                ) : (
                                  <small style={{ color: "#999" }}>
                                    Projet
                                  </small>
                                )}
                              </td>
                              <td>
                                {statement.statement_background_color ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "5px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        backgroundColor:
                                          statement.statement_background_color,
                                        border: "1px solid #ccc",
                                        borderRadius: "3px",
                                      }}
                                    ></div>
                                    <small>
                                      {statement.statement_background_color}
                                    </small>
                                  </div>
                                ) : (
                                  <small style={{ color: "#999" }}>
                                    Projet
                                  </small>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  </Card.Body>
                </Card>
              )}
              {/* Colors Section */}
              <div
                className="border-bottom mb-3 mt-3"
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Palette size={26}></Palette>
                  <h3 className="ms-3">Colors</h3>
                </div>
              </div>

              <Alert
                show={this.state.showColorsAlert !== ""}
                variant={this.state.showColorsAlert}
              >
                <Alert.Heading>
                  {this.state.showColorsAlert === "success"}
                </Alert.Heading>
                <p>
                  {this.state.showColorsAlert === "success"
                    ? "Colors successfully updated."
                    : "Error when updating colors: " + this.state.error}
                </p>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => this.setState({ showColorsAlert: "" })}
                    variant={"outline-" + this.state.showColorsAlert}
                  >
                    Close
                  </Button>
                </div>
              </Alert>

              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Color Theme Configuration</Card.Header>
                <Card.Body>
                  <Row xs={1} md={3} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>Background Color</Form.Label>
                        <Form.Control
                          type="color"
                          name="backgroundColor"
                          value={this.state.backgroundColor}
                          onChange={this.handleChange}
                        />
                        <Form.Text className="text-muted">
                          Main background color for the application
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Form.Label>Header Background Color</Form.Label>
                        <Form.Control
                          type="color"
                          name="headerBackgroundColor"
                          value={this.state.headerBackgroundColor}
                          onChange={this.handleChange}
                        />
                        <Form.Text className="text-muted">
                          Background color for headers and navigation
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group>
                        <Form.Label>Statement Background Color</Form.Label>
                        <Form.Control
                          type="color"
                          name="statementBackgroundColor"
                          value={this.state.statementBackgroundColor}
                          onChange={this.handleChange}
                        />
                        <Form.Text className="text-muted">
                          Background color for statement cards
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <LoadingButton
                    onClick={this.handleColors.bind(this)}
                    variant="primary"
                  >
                    Save Colors
                  </LoadingButton>
                </Card.Body>
              </Card>
              {/* Landing Page Configuration Section */}
              <div
                className="border-bottom mb-3 mt-3"
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Globe size={26}></Globe>
                  <h3 className="ms-3">Landing Page Configuration</h3>
                </div>
              </div>

              <Alert
                show={this.state.showLandingPageAlert !== ""}
                variant={this.state.showLandingPageAlert}
              >
                <Alert.Heading>
                  {this.state.showLandingPageAlert === "success"}
                </Alert.Heading>
                <p>
                  {this.state.showLandingPageAlert === "success"
                    ? "Landing page configuration successfully updated."
                    : "Error when updating landing page configuration: " +
                      this.state.error}
                </p>
                <hr />
                <div className="d-flex justify-content-end">
                  <Button
                    onClick={() => this.setState({ showLandingPageAlert: "" })}
                    variant={"outline-" + this.state.showLandingPageAlert}
                  >
                    Close
                  </Button>
                </div>
              </Alert>

              {/* Header Logo Configuration */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Header Logo Configuration</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Show header logo on landing page"
                      checked={this.state.showHeaderLogo}
                      onChange={(e) =>
                        this.setState({ showHeaderLogo: e.target.checked })
                      }
                    />
                  </Form.Group>

                  <Row xs={1} md={3} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>Header Logo File</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="headerLogoFile"
                          type="file"
                          accept="image/*"
                        />
                        <Form.Text className="text-muted">
                          <b>Format:</b> PNG or JPG file, recommended size
                          300x100px
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    {this.state.headerLogoUrl && (
                      <Col>
                        <div className="text-center">
                          <p className="mb-2">
                            <strong>Current Header Logo:</strong>
                          </p>
                          <img
                            src={
                              BASE_URL +
                              "/projects/" +
                              this.props.params.project_id +
                              "/data/header_logo" +
                              "?t=" +
                              this.state.headerLogoUploadTimestamp
                            }
                            alt="Header Logo"
                            style={{
                              width: "100%",
                              height: 100,
                              objectFit: "contain",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>

                  <div className="d-flex gap-2">
                    <LoadingButton
                      onClick={this.handleHeaderLogoUpload}
                      disabled={!this.state.headerLogoFile}
                      variant="primary"
                    >
                      Upload Header Logo
                    </LoadingButton>
                    {this.state.headerLogoUrl && (
                      <LoadingButton
                        onClick={() =>
                          this.handleFieldUpdate("header_logo_url", "")
                        }
                        variant="danger"
                      >
                        Delete Header Logo
                      </LoadingButton>
                    )}
                  </div>
                </Card.Body>
              </Card>

              {/* Footer Logo Configuration */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Footer Logo Configuration</Card.Header>
                <Card.Body>
                  <Row xs={1} md={3} className="mb-3">
                    <Col>
                      <Form.Group>
                        <Form.Label>Footer Logo File</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="footerLogoFile"
                          type="file"
                          accept="image/*"
                        />
                        <Form.Text className="text-muted">
                          <b>Format:</b> PNG or JPG file, recommended size
                          300x100px
                        </Form.Text>
                      </Form.Group>
                    </Col>
                    {this.state.footerLogoUrl && (
                      <Col>
                        <div className="text-center">
                          <p className="mb-2">
                            <strong>Current Footer Logo:</strong>
                          </p>
                          <img
                            src={
                              BASE_URL +
                              "/projects/" +
                              this.props.params.project_id +
                              "/data/footer_logo" +
                              "?t=" +
                              this.state.footerLogoUploadTimestamp
                            }
                            alt="Footer Logo"
                            style={{
                              width: "100%",
                              height: 100,
                              objectFit: "contain",
                              border: "1px solid #dee2e6",
                              borderRadius: "0.375rem",
                            }}
                          />
                        </div>
                      </Col>
                    )}
                  </Row>

                  <div className="d-flex gap-2">
                    <LoadingButton
                      onClick={this.handleFooterLogoUpload}
                      disabled={!this.state.footerLogoFile}
                      variant="primary"
                    >
                      Upload Footer Logo
                    </LoadingButton>
                    {this.state.footerLogoUrl && (
                      <LoadingButton
                        onClick={() =>
                          this.handleFieldUpdate("footer_logo_url", "")
                        }
                        variant="danger"
                      >
                        Delete Footer Logo
                      </LoadingButton>
                    )}
                  </div>
                </Card.Body>
              </Card>
              {/* Experts Carousel Configuration */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Experts Carousel</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Show experts carousel on landing page"
                      checked={this.state.showExpertsCarousel}
                      onChange={(e) =>
                        this.setState({ showExpertsCarousel: e.target.checked })
                      }
                    />
                  </Form.Group>

                  {this.state.showExpertsCarousel && (
                    <div>
                      <h6 className="mb-3">Experts Configuration</h6>
                      {this.state.landingExperts.map((expert, index) => (
                        <div
                          key={index}
                          className="mb-3 p-3 border rounded bg-light"
                        >
                          <Row>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={expert.name}
                                  onChange={(e) =>
                                    this.updateExpert(
                                      index,
                                      "name",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Expert name"
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={expert.title || ""}
                                  onChange={(e) =>
                                    this.updateExpert(
                                      index,
                                      "title",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Job title"
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label>Specialty</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={expert.specialty || ""}
                                  onChange={(e) =>
                                    this.updateExpert(
                                      index,
                                      "specialty",
                                      e.target.value
                                    )
                                  }
                                  placeholder="Area of expertise"
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group>
                                <Form.Label>Photo</Form.Label>
                                <Form.Control
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) => {
                                    if (e.target.files[0]) {
                                      this.uploadExpertPhoto(
                                        index,
                                        e.target.files[0]
                                      );
                                    }
                                  }}
                                />
                                {expert.photo_url && (
                                  <div className="mt-2 text-center">
                                    <img
                                      src={`${BASE_URL}/projects/${this.props.params.project_id}/experts/${expert.photo_url}`}
                                      alt={expert.name}
                                      style={{
                                        width: "60px",
                                        height: "60px",
                                        objectFit: "cover",
                                        borderRadius: "50%",
                                        border: "2px solid #dee2e6",
                                      }}
                                    />
                                  </div>
                                )}
                              </Form.Group>
                            </Col>
                          </Row>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => this.removeExpert(index)}
                            className="mt-2"
                          >
                            Remove Expert
                          </Button>
                        </div>
                      ))}
                      <Button
                        variant="outline-primary"
                        onClick={this.addExpert}
                        className="mb-3"
                      >
                        + Add Expert
                      </Button>
                    </div>
                  )}
                </Card.Body>
              </Card>

              {/* Contact Form Configuration */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Contact Form</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Show contact form on landing page"
                      checked={this.state.showContactForm}
                      onChange={(e) =>
                        this.setState({ showContactForm: e.target.checked })
                      }
                    />
                  </Form.Group>

                  {this.state.showContactForm && (
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Contact Email</Form.Label>
                          <Form.Control
                            type="email"
                            value={this.state.contactEmail}
                            onChange={(e) =>
                              this.setState({ contactEmail: e.target.value })
                            }
                            placeholder="contact@example.com"
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>Contact Form Title</Form.Label>
                          <Form.Control
                            type="text"
                            value={this.state.contactFormTitle}
                            onChange={(e) =>
                              this.setState({
                                contactFormTitle: e.target.value,
                              })
                            }
                            placeholder="Contact"
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                </Card.Body>
              </Card>

              {/* Vimeo Video Configuration */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Vimeo Video</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Show Vimeo video on landing page"
                      checked={this.state.showVimeoVideo}
                      onChange={(e) =>
                        this.setState({ showVimeoVideo: e.target.checked })
                      }
                    />
                  </Form.Group>

                  {this.state.showVimeoVideo && (
                    <>
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Vimeo Video ID</Form.Label>
                            <Form.Control
                              type="text"
                              value={this.state.vimeoVideoId}
                              onChange={(e) =>
                                this.setState({ vimeoVideoId: e.target.value })
                              }
                              placeholder="123456789"
                            />
                            <Form.Text className="text-muted">
                              Extract the video ID from the Vimeo URL (e.g.,
                              from https://vimeo.com/123456789)
                            </Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Video Title (optional)</Form.Label>
                            <Form.Control
                              type="text"
                              value={this.state.vimeoVideoTitle}
                              onChange={(e) =>
                                this.setState({
                                  vimeoVideoTitle: e.target.value,
                                })
                              }
                              placeholder="Video title"
                            />
                          </Form.Group>
                        </Col>
                      </Row>

                      {/* Video Thumbnail Upload */}
                      <Row className="mb-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label>Custom Video Thumbnail</Form.Label>
                            <Form.Control
                              onChange={this.handleChange}
                              name="vimeoVideoThumbnailFile"
                              type="file"
                              accept="image/*"
                            />
                            <Form.Text className="text-muted">
                              <b>Optional:</b> Upload a custom thumbnail instead
                              of using the default Vimeo thumbnail
                            </Form.Text>
                          </Form.Group>
                        </Col>
                        {this.state.vimeoVideoThumbnailUrl && (
                          <Col md={6}>
                            <div className="text-center">
                              <p className="mb-2">
                                <strong>Current Thumbnail:</strong>
                              </p>
                              <img
                                src={
                                  BASE_URL +
                                  "/projects/" +
                                  this.props.params.project_id +
                                  "/data/vimeo_thumbnail" +
                                  "?t=" +
                                  this.state.vimeoThumbnailUploadTimestamp
                                }
                                alt="Video Thumbnail"
                                style={{
                                  width: "100%",
                                  height: 100,
                                  objectFit: "contain",
                                  border: "1px solid #dee2e6",
                                  borderRadius: "0.375rem",
                                }}
                              />
                            </div>
                          </Col>
                        )}
                      </Row>

                      <div className="d-flex gap-2">
                        <LoadingButton
                          onClick={this.handleVimeoThumbnailUpload}
                          disabled={!this.state.vimeoVideoThumbnailFile}
                          variant="primary"
                        >
                          Upload Thumbnail
                        </LoadingButton>
                        {this.state.vimeoVideoThumbnailUrl && (
                          <LoadingButton
                            onClick={() =>
                              this.handleFieldUpdate(
                                "vimeo_video_thumbnail_url",
                                ""
                              )
                            }
                            variant="danger"
                          >
                            Delete Thumbnail
                          </LoadingButton>
                        )}
                      </div>
                    </>
                  )}
                </Card.Body>
              </Card>

              {/* Footer Text Configuration */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Landing Page Footer</Card.Header>
                <Card.Body>
                  <Form.Group className="mb-3">
                    <Form.Label>Footer Text</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={this.state.landingFooterText}
                      onChange={(e) =>
                        this.setState({ landingFooterText: e.target.value })
                      }
                      placeholder="Additional text to display in the footer of the landing page"
                    />
                    <Form.Text className="text-muted">
                      This text will appear at the bottom of the landing page
                    </Form.Text>
                  </Form.Group>

                  <LoadingButton
                    onClick={this.handleLandingPageConfig}
                    variant="primary"
                  >
                    Save Landing Page Configuration
                  </LoadingButton>
                </Card.Body>
              </Card>
              {/* Form Section */}
              <div
                className="border-bottom mb-3 mt-3"
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <BarChart size={26}></BarChart>
                  <h3 className="ms-3">Form</h3>
                </div>
              </div>

              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">
                  Questions & Form Configuration
                </Card.Header>
                <Card.Body>
                  <Questions
                    projectId={this.props.params.project_id}
                    professions={this.state.professions}
                  ></Questions>
                </Card.Body>
              </Card>

              {/* Results Section */}
              <div
                className="border-bottom mb-3 mt-3"
                style={{
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  style={{
                    flexDirection: "row",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <BarChart size={26}></BarChart>
                  <h3 className="ms-3">Results</h3>
                </div>
              </div>

              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                }}
              >
                <Card.Header as="h5">Export & Analytics</Card.Header>
                <Card.Body>
                  <div className="d-flex gap-3">
                    <LoadingButton
                      onClick={() => this.exportVotes()}
                      variant="primary"
                    >
                      <Download className="me-1"></Download>
                      Export Results
                    </LoadingButton>
                    <LoadingButton
                      onClick={() =>
                        this.props.navigate(
                          "/admin/project/" +
                            this.props.params.project_id +
                            "/presenter_view"
                        )
                      }
                      variant="secondary"
                    >
                      <BarChart className="me-1"></BarChart>
                      View Analytics
                    </LoadingButton>
                  </div>

                  <hr />

                  <h6>Import Results</h6>
                  <Alert
                    show={this.state.showImportVotesAlert !== ""}
                    variant={this.state.showImportVotesAlert}
                  >
                    <p className="mb-0">
                      {this.state.showImportVotesAlert === "success" &&
                      this.state.importResult
                        ? `Event "${this.state.importResult.event_name}" ` +
                          (this.state.importResult.replaced_event_id
                            ? "replaced"
                            : "created") +
                          `: ${this.state.importResult.voters_created} voters, ` +
                          `${this.state.importResult.votes_created} votes, ` +
                          `${this.state.importResult.answers_created} answers.`
                        : "Error when importing results: " + this.state.error}
                    </p>
                    {this.state.showImportVotesAlert === "success" &&
                      this.state.importResult?.warnings?.length > 0 && (
                        <ul className="mb-0 mt-2">
                          {this.state.importResult.warnings.map(
                            (warning, index) => (
                              <li key={index}>
                                <small>{warning}</small>
                              </li>
                            )
                          )}
                        </ul>
                      )}
                    <hr />
                    <div className="d-flex justify-content-end">
                      <LoadingButton
                        onClick={() =>
                          this.setState({ showImportVotesAlert: "" })
                        }
                        variant={"outline-" + this.state.showImportVotesAlert}
                      >
                        Close
                      </LoadingButton>
                    </div>
                  </Alert>
                  <Row xs={1} md={2} className="mb-3">
                    <Col>
                      <Form.Group className="mb-2">
                        <Form.Label>
                          Results file (.xlsx export or .csv)
                        </Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="import_file"
                          type="file"
                          accept=".xlsx,.csv"
                        />
                        <Form.Text className="text-muted">
                          Same format as "Export Results": creates a finished
                          event in this project with the file's voters and
                          votes. The project must contain the same statements
                          (same order) as the exported one. Only the "Votes"
                          sheet is read — the "Stats" sheet is recomputed from
                          the votes, so editing it has no effect.
                        </Form.Text>
                      </Form.Group>
                      <Form.Group className="mb-2">
                        <Form.Label>Event name (optional)</Form.Label>
                        <Form.Control
                          onChange={this.handleChange}
                          name="importEventName"
                          value={this.state.importEventName}
                          type="text"
                          placeholder="Defaults to the file name"
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Target event</Form.Label>
                        <Form.Select
                          onChange={this.handleChange}
                          name="importReplaceEventId"
                          value={this.state.importReplaceEventId}
                        >
                          <option value="">Add a new event</option>
                          {this.state.events.map((event) => (
                            <option key={event.id} value={event.id}>
                              Replace "{event.name}"
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Text className="text-muted">
                          Replacing deletes the target event and its results
                          first. Use it to correct results in Excel and
                          re-import them without duplicating votes in the
                          project statistics.
                        </Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <LoadingButton
                    onClick={this.handleImportVotes}
                    disabled={
                      !this.state.import_file || this.state.isImportingVotes
                    }
                    variant="primary"
                  >
                    Import Results
                  </LoadingButton>
                </Card.Body>
              </Card>

              {/* Delete Project Section */}
              <Card
                className="mb-4"
                style={{
                  borderWidth: 0,
                  boxShadow: "0px 2px 20px -10px rgba(0,0,0,0.2)",
                  borderLeft: "4px solid #dc3545",
                }}
              >
                <Card.Header as="h5" className="text-danger">
                  Danger Zone
                </Card.Header>
                <Card.Body>
                  <p className="text-muted mb-3">
                    <strong>Warning:</strong> This action cannot be undone.
                    Deleting this project will permanently remove all associated
                    data, including events, statements, and voting results.
                  </p>
                  <LoadingButton
                    variant="danger"
                    onClick={this.handleDelete.bind(this)}
                  >
                    Delete Project
                  </LoadingButton>
                </Card.Body>
              </Card>
            </>
          )}
        </Container>
      </div>
    );
  }
}

export default withRouter(ModifyProject);
